const couriersEn = {
  "cour.title": "Couriers",
  "cour.hint": "Connect your own courier accounts to buy shipping labels from orders, track parcels and show live courier rates at checkout.",
  "cour.connected": "Connected",
  "cour.not_connected": "Not connected",
  "cour.connect": "Connect",
  "cour.connect_title": "Connect {name}",
  "cour.labels": "Labels",
  "cour.tracking": "Tracking",
  "cour.rates": "Live rates",
  "cour.cod": "Cash on delivery",
  "cour.webhook_on": "Tracking updates arrive automatically: our webhook is registered with this courier.",
  "cour.webhook_auto": "When you save, we register a tracking webhook with this courier, so delivery updates arrive automatically.",
  "cour.test_mode_hint": "Uses the courier's test system and your test credentials: no real parcels are booked.",
  "cour.enable": "Use {name} for labels and rates",
  "cour.enable_hint": "Staff can buy {name} labels from orders, and courier rates can use it at checkout.",
  "cour.nbox.hint": "Qatar's tech-forward 3PL: same-day delivery, cash on delivery and live GPS tracking.",
  "cour.nbox.steps": "Create an NBOX seller account (nbox.qa) and set up your shop in NBOX NOW.\nEnter the email and password you sign in to NBOX NOW with, and your shop domain (the shop identifier NBOX uses for your store).\nSave: we register a tracking webhook with NBOX for you, so delivery updates arrive by themselves.\nUse Test connection. In test mode, labels are booked on NBOX's staging system.",
  "cour.aramex.hint": "Gulf and international express: labels, live rates, tracking and cash on delivery.",
  "cour.aramex.steps": "Open an Aramex business account and ask your Aramex account manager for API access (Shipping Services API).\nAramex sends an API username and password, plus your account number, PIN, entity (for example DOH) and country code (for example QA).\nEnter them below. In test mode, use the test account Aramex gives you for its sandbox.\nSave, then use Test connection. Tracking is checked every 2 hours. Aramex can't cancel a booked shipment through its API: contact Aramex if you need to.",
  "cour.dhl_express.hint": "International express with DHL: labels, live rates and tracking.",
  "cour.dhl_express.steps": "You need a DHL Express account. Register at developer.dhl.com, create an app with the MyDHL API, and ask your DHL Express contact to approve it.\nDHL issues an API key and secret (test ones first). Enter them with your 9-digit DHL Express account number.\nSave, then use Test connection. Tracking is checked every 2 hours.\nDHL doesn't collect cash on delivery. An unused waybill isn't billed, so cancelling a DHL label here just voids it.",
  "cour.field.email": "Email",
  "cour.field.password": "Password",
  "cour.field.shop_domain": "Shop domain",
  "cour.field.username": "API username",
  "cour.field.account_number": "Account number",
  "cour.field.account_pin": "Account PIN",
  "cour.field.account_entity": "Account entity",
  "cour.field.account_country_code": "Account country code",
  "cour.field.api_key": "API key",
  "cour.field.api_secret": "API secret",
  "lbl.create": "Create shipping label",
  "lbl.title": "Create shipping label",
  "lbl.buy": "Buy label",
  "lbl.bought": "Label created · {tracking}",
  "lbl.get_rates": "Get rates",
  "lbl.no_couriers": "Connect a courier to buy shipping labels.",
  "lbl.connect": "Go to Shipping and delivery",
  "lbl.route": "From {from} to {to}",
  "lbl.courier": "Courier",
  "lbl.service": "Service",
  "lbl.service_default": "Courier's choice",
  "lbl.package": "Package",
  "lbl.package_none": "Default size (20 × 15 × 10 cm)",
  "lbl.weight": "Total weight (kg)",
  "lbl.weight_hint": "Products and packaging together.",
  "lbl.no_rates": "This courier didn't return a price for this parcel.",
  "lbl.days": "{n, plural, one {# day} other {# days}}",
  "lbl.collect_cod": "Collect {amount} on delivery",
  "lbl.collect_cod_hint": "The courier collects the amount due from the customer and pays it to you.",
  "lbl.no_cod": "{name} doesn't collect cash on delivery.",
  "lbl.notify": "Send the customer the tracking details",
  "lbl.print": "Print label",
  "lbl.refresh": "Refresh tracking",
  "lbl.tracking_updated": "Tracking updated",
  "lbl.cancel": "Cancel label",
  "lbl.cancel_title": "Cancel this shipping label?",
  "lbl.cancel_body": "The booking is cancelled with the courier and the items go back to unfulfilled.",
  "lbl.cancelled": "Label cancelled",
  "lbl.cod_amount": "COD {amount}",
  "lbl.fewer": "Show fewer",
  "lbl.all_events": "Show all {n} updates",
  "lbl.status.label_pending": "Label being prepared",
  "lbl.status.active": "Label created",
  "lbl.status.delivered": "Delivered",
  "lbl.status.failed": "Failed",
  "lbl.status.returned": "Returned",
  "lbl.status.cancelled": "Cancelled",
  "ship.cond.carrier": "Courier rate",
  "ship.live_rate": "Live courier rate",
  "ship.carrier_summary": "{name} live rate",
  "ship.fallback_short": "fallback {v}",
  "ship.carrier_hint": "At checkout the price is the courier's live quote for the parcel, plus your markup.",
  "ship.carrier_cheapest": "Cheapest service",
  "ship.markup_percent": "Markup (%)",
  "ship.markup_percent_hint": "Add a percentage to the quote, or a negative one to subsidise it.",
  "ship.markup_fixed": "Fixed amount added",
  "ship.fallback": "Fallback price",
  "ship.fallback_hint": "Shown when the courier doesn't answer in time. Leave empty to hide the rate then.",
} as const;

export default couriersEn;
